import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../components/Utils/Custom/HelperCode";
import { GeneralReducerModel } from "../../components/Utils/Models/store";

const initialState: GeneralReducerModel = {
  showLoadingComponent: false,
  interceptorErrorMessage: "",
  interceptorErrorId: 0,
};

//////////////Reducer Slice//////////////////////
const showLoadingComponent_Reducer = (state: GeneralReducerModel, action: any) => {
  return updateObject(state, { showLoadingComponent: action.activate } as GeneralReducerModel);
};

const showErrorTextInterceptor_Reducer = (state: GeneralReducerModel, action: any) => {
  return updateObject(state, {
    interceptorErrorMessage: action.errorCode,
    interceptorErrorId: Math.random(),
  } as GeneralReducerModel);
};

/////REDUCER//////
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SHOW_LOADING_COMPONENT:
      return showLoadingComponent_Reducer(state, action);
    case actionTypes.SHOW_ERROR_TEXT_INTERCEPTOR:
      return showErrorTextInterceptor_Reducer(state, action);
    default:
      return state;
  }
};
export default reducer;
